import { useNavigate, useLocation } from "react-router-dom";
import { GraduationCap, Briefcase } from "lucide-react";

export function PanelSwitcher() {
  const navigate = useNavigate();
  const location = useLocation();
  const isLateral = location.pathname.startsWith("/admin/lateral");

  return (
    <div className="flex items-center rounded-lg border bg-gray-100 p-1 gap-1">
      <button
        onClick={() => !isLateral || navigate("/dashboard")}
        className={`flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium transition-colors ${
          !isLateral
            ? "bg-white text-blue-700 shadow-sm"
            : "text-gray-500 hover:text-gray-700"
        }`}
      >
        <GraduationCap className="h-3.5 w-3.5" />
        Campus
      </button>
      <button
        onClick={() => isLateral || navigate("/admin/lateral")}
        className={`flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium transition-colors ${
          isLateral
            ? "bg-white text-blue-700 shadow-sm"
            : "text-gray-500 hover:text-gray-700"
        }`}
      >
        <Briefcase className="h-3.5 w-3.5" />
        Lateral
      </button>
    </div>
  );
}
